import type { SubZoneResponse } from 'api/__GENERATED';
import * as R from 'remeda';

import { toProductivityGoal } from './toProductivityGoal';

// Maps a single SubZone DTO from the generated API client onto the
// normalized `Data.SubZone` shape. The DTO's `productivityGoals` list becomes
// an inline `targets: ProductivityTarget[]` — goals missing `validFrom` are
// dropped (they can't be anchored to a day), and the resulting targets are
// sorted chronologically by day id so consumers can assume order.
function toSubZone(dto: SubZoneResponse) {
  const { id, name, description, zoneId, subZoneCode, productivityGoals } = dto;

  const targets = R.pipe(
    productivityGoals ?? [],
    R.map(toProductivityGoal),
    R.filter(R.isDefined),
    R.sortBy((target) => target.date.id),
  );

  const subZone: Data.SubZone = {
    id,
    name,
    description: description ?? '',
    zoneId,
    code: subZoneCode,
    targets,
  };

  return subZone;
}

export { toSubZone };
